import { isVisibleOnScreen, getHeaderHeight, toggleBodyOverscroll } from "./common";

const DROPDOWN_MENU_HEADER = $('#menu-sub-menu .dropdown-menu-header');
const DROPDOWN_MENU_HEADER_COLLAPSE = $('#menu-sub-menu .dropdown-menu-header.collapse.dropright.product-image.col-6');
const SOLUTION_MENU_HEADER = $("#menu-solution-menu .dropdown-menu-header");
const SOLUTION_MENU_HEADER_COLLAPSE = $('#menu-solution-menu .dropdown-menu-header.collapse');
const USERGUIDE_MENU_HEADER = $("#menu-userguide-menu .dropdown-menu-header");
const USERGUIDE_MENU_HEADER_COLLAPSE = $('#menu-userguide-menu .dropdown-menu-header.collapse');
const MENU_HOVER_TIMEOUT = 100;
var megaMenuTimeout;
var topMenuTimeout;
var subMenuTimeout;
var topNavSlimTimeoutTimer = null;
var megaMenuTimeoutTimer = null;
var overlayTimeoutTimer = null;

$(function () {
  showProductMenu();
  closeProductMenu();
  closeResponsiveMenu();
  getCountry();
  updateMenuDropDown();
  repositionNavMenu();

  $(document).on('click', '.menu-sub-menu .top-menu', function (event) {
    if ($(this).hasClass('view-all') === false) {
      event.stopPropagation();
    }
  }).on('mouseenter', '.menu-sub-menu .top-menu', function (event) {
    clearTimeout(topMenuTimeout);
    clearTimeout(subMenuTimeout);
    topMenuTimeout = setTimeout(function () {
      updateTopMenuDropDown(event)
    }, MENU_HOVER_TIMEOUT);
  }).on('mouseleave', '.menu-sub-menu .top-menu', function () {
    clearTimeout(topMenuTimeout);
  });

  $(document).on('click', '.menu-sub-menu .sub-menu', function (event) {
    if ($(this).hasClass('view-all') === false) {
      event.stopPropagation();
    }
  }).on('mouseenter', '.menu-sub-menu .sub-menu', function (event) {
    clearTimeout(topMenuTimeout);
    clearTimeout(subMenuTimeout);
    subMenuTimeout = setTimeout(function () {
      updateSubMenuDropDown(event)
    }, MENU_HOVER_TIMEOUT);
  }).on('mouseleave', '.menu-sub-menu .sub-menu', function () {
    clearTimeout(subMenuTimeout);
  });

  $('[data-toggle="tooltip"]').tooltip();

  document.addEventListener("touchmove", repositionNavMenu, false);
});

window.addEventListener('scroll', function() { repositionNavMenu(); setMegaMenuStyleTop(); });
window.addEventListener('resize', function() { repositionNavMenu(); setMegaMenuStyleTop();});

/**
 * Get the name of the user country
 */
function getCountry() {
  const rodeCountry = document.getElementById('rodeCountry');
  if (rodeCountry !== null) {
    $.get('https://extreme-ip-lookup.com/json/', (response) => {
      if (response) {
        rodeCountry.innerHTML = response.country;
      }
    });
  }
}

/**
 * Close the product menu clicking everywhere
 */
function closeProductMenu() {
  $(document).on('click', (event) => {
    var click = $(event.target);
    var menu = $('.menu-sub-menu');
    var _open = menu.hasClass('show');
    // Check the click is not inside the div menu
    if (_open === true && (!menu.has(click)[0] && click.get(0).id !== menu.get(0).id)) {
      $(menu).collapse('hide');
      // toggleBodyOverscroll(false);
      $('.menu-sub-menu .dropdown-item.opened').collapse('hide');
    }
  });
  // $(document).on('mouseleave',  '#menu-sub-menu, #menu-solution-menu', function(){
  //   clearTimeout(topMenuTimeout);
  //   topMenuTimeout = setTimeout(() => {
  //     var menu = $('.menu-sub-menu');
  //     $(menu).collapse('hide');
  //     toggleBodyOverscroll(false);
  //     $('.menu-sub-menu .dropdown-item.opened').collapse('hide');  
  //   }, MENU_HOVER_TIMEOUT);
  // }).on('mouseenter', '#menu-sub-menu, #menu-solution-menu', function(){
  //   clearTimeout(topMenuTimeout);
  // });
  $(document).on('mouseenter', '.hide-mega-menu', function() {
    var menu = $('.menu-sub-menu');
    $(menu).collapse('hide');
    // toggleBodyOverscroll(false);
    $('.menu-sub-menu .dropdown-item.opened').collapse('hide');
  });
}

/**
 * Update the list of the menu 
 * Open the Product Megamenu
 */
function updateMenuDropDown() {
  $('#menuProduct', '#menuProductSlim')
    .on('click', (event) => {
      var click = $(event.target);
      var _top_open = $(DROPDOWN_MENU_HEADER).hasClass('show');
      var _sub_open = $(DROPDOWN_MENU_HEADER_COLLAPSE).hasClass('show');
      if ((_top_open === true || _sub_open === true) && click.hasClass('dropdown-toggle')) {
        $(DROPDOWN_MENU_HEADER).collapse('hide');
        $(DROPDOWN_MENU_HEADER_COLLAPSE).collapse('hide');
      }
    });

  $('#menuSolution', '#menuSolutionSlim')
    .on('click', (event) => {
      var click = $(event.target);
      var _top_open = $(SOLUTION_MENU_HEADER).hasClass('show');
      var _sub_open = $(SOLUTION_MENU_HEADER_COLLAPSE).hasClass('show');
      if ((_top_open === true || _sub_open === true) && click.hasClass('dropdown-toggle')) {
        $(SOLUTION_MENU_HEADER).collapse('hide');
        $(SOLUTION_MENU_HEADER_COLLAPSE).collapse('hide');
      }
    });

  $('#menuUserGuide', '#menuUserGuideSlim')
    .on('click', (event) => {
      var click = $(event.target);
      var _top_open = $(USERGUIDE_MENU_HEADER).hasClass('show');
      var _sub_open = $(USERGUIDE_MENU_HEADER_COLLAPSE).hasClass('show');
      if ((_top_open === true || _sub_open === true) && click.hasClass('dropdown-toggle')) {
        $(USERGUIDE_MENU_HEADER).collapse('hide');
        $(USERGUIDE_MENU_HEADER_COLLAPSE).collapse('hide');
      }
    });
}

/**
 * Update the top list of the menu 
 * ie. root level, eg, Mircophone, Interface, Consoles, etc
 */
function updateTopMenuDropDown(event) {
  event.stopPropagation();
  var click = $(event.target);
  if ($(event.target).closest('.top-menu').length) {
    click = $(event.target).closest('.top-menu');
  }
  if (!$(click).hasClass('opened')) {
    let target = $(click).attr('data-target');
    if (typeof target !== 'undefined') {
      $(target).collapse('show');
      $(".menu-sub-menu").find('.opened').removeClass('opened');
      let shown = $(".dropdown-menu-header.show");
      $(shown).removeClass('show');
      $(shown).collapse('hide');
      $(click).addClass('opened')
      if ($("#featuredProduct").length) {
        if (target.indexOf('#dropdownSub') >= 0) {
          $("#featuredProduct").addClass('slide-away');
        } else {
          $("#featuredProduct").removeClass('slide-away');
        }
      }
      if ($("#featureProductNew").length) {
        if (target.indexOf('#dropdownSub') >= 0) {
          $("#featureProductNew").addClass('d-none');
        }else{
          $("#featureProductNew").removeClass('d-none');
        }
      }
    }
  }
}

/**
 * Update the sub list of the menu 
 * ie. sub level, eg. Studio, Camera, Wirelss, etc
 */
function updateSubMenuDropDown(event) {
  event.stopPropagation();
  var click = $(event.target);
  if ($(event.target).closest('.sub-menu').length) {
    click = $(event.target).closest('.sub-menu');
  }
  if (!$(click).hasClass('opened')) {
    let target = $(click).attr('data-target');
    if (typeof target !== 'undefined') {
      $(".menu-sub-menu .sub-menu.opened").removeClass('opened');
      let shown = $(".dropdown-menu-header.product-image.show");
      $(shown).removeClass('show');
      $(shown).collapse('hide');
      $(target).collapse('show');
      $(click).addClass('opened');
      if ($("#featuredProduct").length) {
        $("#featuredProduct").addClass('slide-away');
      }
      if($('#featureProductNew').length){
        $("#featureProductNew").addClass('d-none');
      }
      if ($("#featureProductNew").length) {
        if(target !== 'featureProductNew'){
          $("#featureProductNew").addClass('d-none');
        }else{
          $("#featureProductNew").removeClass('d-none');
        }
      }
    }
  }
}

/**
 * Close the menu clicking everywhere
 */
function closeResponsiveMenu() {
  $(document).on('click', (event) => {
    var click = $(event.target);
    var menu = $('#navbarResponsive');
    var _open = menu.hasClass('show');
    if ($(click).hasClass('close_menu') || $(click).closest('.close_menu').length) {
      $(menu).collapse('hide');
      toggleBodyOverscroll(false);
    }
  });

  $(document).on('hide.bs.collapse', '.menu-sub-menu.collapse', function () {
    overlayTimeoutTimer = setTimeout(() => {
      hideOverlay();
    }, 0);
  });
}

function repositionNavMenu(){
  // show the #top-nav-slim base on the position of the Y co-ord
  clearTimeout(topNavSlimTimeoutTimer);
  topNavSlimTimeoutTimer = setTimeout(() => {
    let currentScrollY = window.scrollY;
    let headerHeight = getHeaderHeight();
    let navbarToggler = document.getElementById('navbar-toggler');
    if(getComputedStyle(navbarToggler).display == 'none'){
      if(currentScrollY >= headerHeight){
        toggleTopNavSlim(true);
      }else{
        toggleTopNavSlim(false);
      }
    }else{
      toggleTopNavSlim(false);
    }
  }, 50);
}

function toggleTopNavSlim(shown){
  let topNavSlim = document.getElementById('top-nav-slim');
  if(topNavSlim){
    if(typeof shown === 'undefined'){
      shown = false;
    }
    if(shown){
      topNavSlim.classList.remove('d-none');
      topNavSlim.classList.add('d-block');
    }else{
      topNavSlim.classList.add('d-none');
      topNavSlim.classList.remove('d-block');
    }
  }
}

function showProductMenu() {
  $(document).on('mouseenter', '#menuProductSlim, #menuProduct', function (event) {
    event.preventDefault();
    clearTimeout(megaMenuTimeout);
    megaMenuTimeout = setTimeout(() => {
      showMegamenu($(this));
    }, MENU_HOVER_TIMEOUT);
  }).on('mouseleave', '#menuProductSlim, #menuProduct', function () {
    clearTimeout(megaMenuTimeout);
  });

  $(document).on('mouseenter', '#menuSolutionSlim, #menuSolution', function (event) {
    event.preventDefault();
    clearTimeout(megaMenuTimeout);
    megaMenuTimeout = setTimeout(() => {
      showMegamenu($(this));
    }, MENU_HOVER_TIMEOUT);
  }).on('mouseleave', '#menuSolutionSlim, #menuSolution', function () {
    clearTimeout(megaMenuTimeout);
  });

  $(document).on('mouseenter', '#menuUserGuideSlim, #menuUserGuide', function (event) {
    event.preventDefault();
    clearTimeout(megaMenuTimeout);
    megaMenuTimeout = setTimeout(() => {
      showMegamenu($(this));
    }, MENU_HOVER_TIMEOUT);
  }).on('mouseleave', '#menuUserGuideSlim, #menuUserGuide', function () {
    clearTimeout(megaMenuTimeout);
  });

  $(document).on('show.bs.collapse', '.menu-sub-menu.collapse', function () {
    clearTimeout(overlayTimeoutTimer);
    showOverlay();
  });
}

function showMegamenu(element) {
  $('.menu-sub-menu').removeClass('show');
  let showTarget = $(element).attr('data-target');
  if ((typeof showTarget !== 'undefined') && $(showTarget).length) {
    $(showTarget).collapse('show');
    // toggleBodyOverscroll(true);
    let opened_top_menu = $(".dropdown-item.top-menu.open").length;
    var menu = document.getElementById('menu-sub-menu');
    var solutionmenu = document.getElementById('menu-solution-menu');
    if (opened_top_menu === 0) {
      $(".dropdown-item.top-menu").eq(0).trigger('mouseenter');
      var topnav = document.getElementById('top-nav');
      var topnavslim = document.getElementById('top-nav-slim');
      let rect = topnav.getClientRects();
      let offsetHeight = topnav.offsetHeight + rect[0].top;
      if(!topnavslim.classList.contains('d-none')){
        offsetHeight = topnavslim.offsetHeight;
      }
      menu.style.top = offsetHeight + 'px';
      solutionmenu.style.top = offsetHeight + 'px';
    }
  }
}

function setMegaMenuStyleTop()
{
  clearTimeout(megaMenuTimeoutTimer);
  megaMenuTimeoutTimer = setTimeout(() => {
    let menu = document.getElementById('menu-sub-menu');
    let solutionmenu = document.getElementById('menu-solution-menu');
    let topnav = document.getElementById('top-nav');
    let topnavslim = document.getElementById('top-nav-slim');
    let topnavRectBound = topnav.getBoundingClientRect();
    let navbarToggler = document.getElementById('navbar-toggler');
    if(getComputedStyle(navbarToggler).display != 'none'){
      menu = $('#menu-sub-menu');
      solutionmenu = $('#menu-solution-menu');
      menu.collapse('hide');
      solutionmenu.collapse('hide');
      return;
    }
    let offsetHeight = topnavRectBound.height + topnavRectBound.top;
    if(getComputedStyle(topnavslim).display != 'none'){
      offsetHeight = topnavslim.offsetHeight;
    }
    menu.style.top = offsetHeight + 'px';
    solutionmenu.style.top = offsetHeight + 'px';  
  }, 50);
}

function showOverlay() {
  const overlay = document.getElementById('overlay');
  if (typeof overlay !== 'undefined') {
    overlay.classList.remove('d-none');
  }
}
function hideOverlay() {
  const overlay = document.getElementById('overlay');
  if (typeof overlay !== 'undefined') {
    overlay.classList.add('leaving');
    setTimeout(() => {
      overlay.classList.remove('leaving');
      overlay.classList.add('d-none');
    }, 0);
  }
}

const header = new Vue({
  el: "#header",
  name: "header"
});

window.dataLayer = window.dataLayer || [];